// setTimeout(() => {
//   const swatches = document.getElementsByClassName("single-option-selector");
//   for (let i = 0; i < swatches.length; i++) {
//     swatches[i].addEventListener("change", getDiscountedPrice);
//   }
// }, 700);

// function getDiscountedPrice() {
//   var oldVariant = document.getElementsByClassName("axt-cp-custom")[0].id;
//   var oldProduct = document.getElementsByClassName("axt-cp-custom")[0].getAttribute("axt-cp-variant-id");
  
//   setTimeout(() => {      
//       // Remove old variant and product IDs
//     document.getElementsByClassName("axt-cp-custom")[0].classList.remove(oldVariant);
//     document.getElementsByClassName("axt-cp-custom")[0].classList.remove(oldProduct);

//     var variantId = document.querySelector('[name="id"]').value;
//     var productId = document.querySelector('[name="product-id"]').value;

//     // Add new variant and product IDs
//     document.getElementsByClassName("axt-cp-custom")[0].classList.add(variantId);
//     document.getElementsByClassName("axt-cp-custom")[0].classList.add(productId);

//     document.getElementsByClassName("axt-cp-custom")[0].id = productId;
//     document.getElementsByClassName("axt-cp-custom")[0].setAttribute("axt-cp-variant-id", variantId);
//   }, 700);
// }

setTimeout(() => {
  const selectElements = document.getElementsByClassName("single-option-selector");

  Array.from(selectElements).forEach((selectElement) => {
    selectElement.addEventListener("change", (event) => {

      // Currently selected option
      const selectedOption =
        event.target.options[event.target.selectedIndex];

      console.log("Selected value:", selectedOption.value);
      console.log("Selected text:", selectedOption.text);

      var oldVariant = document
        .getElementsByClassName("axt-cp-custom")[0]
        .getAttribute("axt-cp-variant-id");

      
        var variantId = document.querySelector('[name="id"]').value;

        var customElement =
          document.getElementsByClassName("axt-cp-custom")[0];

        customElement.classList.add(variantId);

        if (oldVariant) {
          customElement.classList.remove(oldVariant);
        }

        customElement.setAttribute(
          "axt-cp-variant-id",
          variantId
        );

        console.log("New variant ID:", variantId);
        console.log("Selected option:", selectedOption.value);

      
    });
  });

}, 900);